import { render } from "./Consolidation.vue?vue&type=template&id=10a543a8&scoped=true"
import script from "./Consolidation.vue?vue&type=script&lang=js"
export * from "./Consolidation.vue?vue&type=script&lang=js"

import "./Consolidation.vue?vue&type=style&index=0&id=10a543a8&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a543a8"]])

export default __exports__